import Environment, { Version } from "./environment.interface";

/**
 * Environment configuration for PRD
 */
export const environment : Environment = {
  appInsightsInstrumentationKey: "35cf11ff-2e96-410b-8e14-ea3eb61e7594",
  production: true,
  version: Version.current,
  apiUrl: "https://prd-hhp-api-hartmann-info.hrt.cloud",
  siteUrl: "https://www.hartmann.info/app/InfectionPrevention/",
  androidUrl: "https://play.google.com/apps/testing/com.paulhartmann.bodeHygienePlatform",
  iosUrl: "https://itunes.apple.com/in/app/testflight/id899247664?mt=8",
  imageUrl: "https://storagedhhpprd.blob.core.windows.net:443",
  helpUrl: "https://www.hartmann.info/app/InfectionPrevention/elearning",
  //helpUrl:"https://hartmann.info/app/InfectionsPrevention/help/!SSL!/index.htm",
  //forgetPasswordUrl:"https://sithartmannclouddhhpb2c.b2clogin.com/sithartmannclouddhhpb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_resetpassword&client_id=ef383ab0-b9d4-412b-bd58-cc543cdc8014&nonce=defaultNonce&redirect_uri=http%3A%2F%2Flocalhost%3A5000%2Fsecurity%2Fsignin-callback&scope=openid&response_type=id_token&prompt=login",
  isUserName: true,
  loginAccesstok: "8080808080808080",
  signUpUrl: "https://www.hartmann.info/app/healthplus/home?registration",
  PLATFORM_AUTH: 'https://prd-auth-api-hartmann-info.hrt.cloud/api/v0.3/',
  dateFormat: {
    'en': 'DD/MM/YYYY',
    'de': 'DD.MM.YYYY',
    'fr': 'DD/MM/YYYY',
    'cs': 'DD/MM/YYYY',
    'sk': 'DD/MM/YYYY',
    'es': 'DD/MM/YYYY',
    'nl': 'DD/MM/YYYY',
    'hu': 'DD/MM/YYYY',   
    'ca': 'DD/MM/YYYY',
    'pt': 'DD/MM/YYYY'
  },
  timeFormat: {
    en: 12,
    de: 24,
    fr: 24,
    cs: 24,
    sk: 24,
    es: 24,
    nl: 24,
    hu: 24,
    ca: 24,
    pt: 24
  },
  bsCalenderDateConfig: {
    rangeInputFormat: 'MM/DD/YY',
    containerClass: 'theme-dark-blue dashboardCalender',
    adaptivePosition: true,
    showWeekNumbers: false,
    isAnimated: true
  },
  baseUrl: "",
  consumerKey: "130E264F-1B07-4C62-88AD-02DE8CBF9713",
  check: {
    api_url: "https://prd-hygiene-check-api-hartmann-info.hrt.cloud/",
    signInUrl: "https://prd-hhp-api-hartmann-info.hrt.cloud/api/Accounts/Authenticate",
    refreshTokenUrl: "https://prd-hhp-api-hartmann-info.hrt.cloud/api/Accounts/RefreshToken",
    apiHartmannUrl: "https://prd-hhp-api-hartmann-info.hrt.cloud/api/",
  },
  inactivityModal: {
    countdown: 30,
    inactivityIntervalTime: 60 * 60 * 1000
  }
};
